import { Seat } from './types';

export const MAX_SELECTED_ROOMS = Infinity; // No limit
export const MAX_SELECTED = Infinity; // Keep for backward compatibility

// Check if a seat belongs to a room (not an open desk area)
export function isRoomSeat(seat: Seat): boolean {
  // Open desk areas have section IDs starting with "OPEN_"
  return !seat.sectionId.startsWith('OPEN_');
}

export function isSelectable(seat: Seat): boolean {
  return seat.status === 'available';
}

export function generateSeatId(sectionId: string, index: number): string {
  const paddedIndex = String(index + 1).padStart(3, '0');
  return `${sectionId}-${paddedIndex}`;
}